import React, { useMemo } from "react";
import DropdownSelect from "./DropdownSelect";

const DropDown = ({
  value,
  options,
  placeholder,
  isMultiSelect,
  onChange,
  onBlur,
  isDisabled,
  dataField,
  isCardSection,
  isdropdownOpen
}) => {
  const getSelectedOptions = useMemo(() => {
    if (isMultiSelect) {
     if (Array.isArray(value)) {
        return options.filter(option => value.includes(option.value));
      } else {
        return [];
      }
    } else if (typeof value === 'object' && !Array.isArray(value)) {
      return options?.find(option => option.value === value.value);
    } else {
      return options?.find(option => option.value === value);
    }
  }, [value, options, isMultiSelect, isCardSection]);

  return (
    <span className="custom-input">
      <DropdownSelect
        placeholder={placeholder}
        isMultiSelect={isMultiSelect}
        optionsValue={options}
        value={getSelectedOptions}
        handleDropdownChange={onChange}
        handleDropdownBlur={onBlur}
        isDropdownDisabled={isDisabled}
        dataField={dataField}
        isdropdownOpen={isdropdownOpen}
      />
    </span>
  );
};

export default DropDown;
